import { Text, Secondary, IconTick, Box } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { IEmail } from '../../../stores/JobApplicationStore/Email';
import { TimeAgo } from '../../common';
import SyncMessage from '../../common/SyncMessage';
import HotjarMask from '../../common/HotjarMask';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import type { Locale as MelwaysLocale } from '@seek/melways-sites';

interface Props {
  email: IEmail;
  locale: MelwaysLocale;
}

const EmailItemMeta = ({ email, locale }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Box display="flex" justifyContent="spaceBetween">
      <Text>
        <Secondary>
          <HotjarMask>{email.from}</HotjarMask>
        </Secondary>
      </Text>
      <div data-testid="sent-date">
        <SyncMessage
          message={
            <Text tone="positive">
              <IconTick /> {t('Sent')}
            </Text>
          }
          showMessage={email.isNew}
          onHide={() => email.markedAsNotNew()}
        >
          <Text tone="secondary">
            <TimeAgo date={email.sentDate} locale={locale} />
          </Text>
        </SyncMessage>
      </div>
    </Box>
  );
};

export default observer(EmailItemMeta);
